import ChurnReasonEnum from '../enums/ChurnReason.enum';
import ReferReasonEnum from '../enums/ReferReason.enum';
import ReportTypeEnum from '../enums/CoverageType.enum';
import { ReactComponent as TvIcon } from '../static/icons/tv.svg';
import { ReactComponent as ReelIcon } from '../static/icons/reel.svg';
import { ReactComponent as BookIcon } from '../static/icons/book.svg';
import GroupAccessEnum from '../enums/GroupAccessEnum';
import DocRoleEnum from 'enums/DocRoleEnum';
import GroupRoleEnum from 'enums/GroupRoleEnum';

export const ChurnReasonOptions = {
  [ChurnReasonEnum.NOT_ENOUGH_VOLUME]: 'Insufficient volume of data',
  [ChurnReasonEnum.REPORT_QUALITY_NEEDS_IMPROVEMENT]: 'Report quality requires enhancement',
  [ChurnReasonEnum.DID_NOT_USE_ENOUGH]: 'Under utilization of service',
  [ChurnReasonEnum.PRICING_TOO_EXPENSIVE]: 'Cost exceeds perceived value',
  [ChurnReasonEnum.NEED_MORE_FEATURES]: 'Requirement for additional features',
  [ChurnReasonEnum.INTEND_TO_USE_DIFFERENT_TOOL]: 'Intention to adopt an alternative solution',
  [ChurnReasonEnum.OTHER]: 'Other'
};

export const referReasonOptions = {
  [ReferReasonEnum.SEARCHING_FOR_SOLUTION]: 'Searching for a Solution',
  [ReferReasonEnum.ADVERTISEMENT]: 'Advertisement',
  [ReferReasonEnum.REFERRED_BY_FRIEND]: 'Referred by a Friend',
  [ReferReasonEnum.OTHER]: 'Other'
};
export const ALLOWED_FILE_EXTENSIONS = ['pdf', 'doc', 'docx'];

export const PIPELINE_COMPLETION_TIMEOUT_MAX_MIN = 90; //1.5 hr = 90 min

export const COVERAGE_TYPE_MAPPINGS = [
  { value: ReportTypeEnum.SCRIPT, label: 'Script Coverage', icon: ReelIcon },
  { value: ReportTypeEnum.SERIES, label: 'TV Series Coverage', icon: TvIcon },
  { value: ReportTypeEnum.BOOK, label: 'Book Coverage', icon: BookIcon }
];

export const UserStatusDropdownOptions = [
  { value: 'member', label: 'Member', color: '#34C759', backgroundColor: 'rgba(52,199, 89, 0.1)' },
  { value: 'admin', label: 'Admin', color: '#4FAAFE', backgroundColor: 'rgba(104 ,183, 255, 0.1)' },
  {
    value: 'suspended',
    label: 'Suspend',
    color: '#F75B4F',
    backgroundColor: 'rgba(247, 91, 80, 0.1)'
  }
];
export const GROUP_ACCESS_OPTIONS = [
  { label: 'Can View', value: GroupAccessEnum.GROUP_DOC_VIEWER },
  { label: 'Can Download', value: GroupAccessEnum.GROUP_DOC_DOWNLOADER },
  { label: 'Can Edit', value: GroupAccessEnum.GROUP_DOC_EDITOR }
];

export const GROUP_ROLE_OPTIONS = [
  { label: 'Owner', value: GroupRoleEnum.GROUP_OWNER },
  { label: 'Member', value: GroupRoleEnum.GROUP_MEMBER },
];

export const DOCUMENT_ACCESS_OPTIONS = [
  { label: 'Owner', value: DocRoleEnum.DOC_OWNER },
  { label: 'Can View', value: DocRoleEnum.DOC_VIEWER },
  { label: 'Can Download', value: DocRoleEnum.DOC_DOWNLOADER },
  { label: 'Can Edit', value: DocRoleEnum.DOC_EDITOR }
];
